module.exports = __webpack_public_path__ + "img/K43-uzbekistan.575373ef.png";